import { ButtonConfig } from "@web-solutions/core/payment/constants";

import { LString, t } from "@web-solutions/module-localization";
import { useAppSelector } from "@web-solutions/store/types";
export const useButtonTitleByConfig = (
  config: ButtonConfig,
  defaultTKeyText: string,
  details?: object
) => {
  let { uppercaseTitle, title } = config || {};
  const locale = useAppSelector((state) => state.locale.locale);

  // 1. Если title начинается с "_" - это ключ локализации
  if (title && typeof title === "string" && title[0] === "_") {
    const localized = t(title);
    return uppercaseTitle ? localized.toUpperCase() : localized;
  }

  // 2. Если title - это объект LString
  if (title && typeof title === "object") {
    const upgradeTitle = title[locale as keyof LString] as string;
    if (upgradeTitle) {
      return uppercaseTitle ? upgradeTitle.toUpperCase() : upgradeTitle;
    }
  }

  // 3. Если title - это уже готовая строка
  if (title && typeof title === "string") {
    return uppercaseTitle ? title.toUpperCase() : title;
  }

  // 4. Fallback - всегда возвращаем значение по умолчанию
  const defaultTitle = t(defaultTKeyText);
  return uppercaseTitle ? defaultTitle.toUpperCase() : defaultTitle;
};
// export const useButtonTitleByConfig = (
//   config: ButtonConfig,
//   defaultTKeyText: string,
//   details?: object,
// ) => {
//   let { uppercaseTitle, title } = config || {};
//   const locale = useAppSelector((state) => state.locale.locale);

//   if (title && typeof title === "string" && title[0] === "_") {
//     return t(title);
//   }

//   if (title) {
//     const upgradeTitle = title[locale as keyof LString] as string;

//     return uppercaseTitle ? upgradeTitle.toUpperCase() : upgradeTitle;
//   }
// };
